module.exports = __webpack_public_path__ + "static/media/TP-link.467da650.jpg";